import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import "./Admin/admin.css";
import buildUrl from '../../objects/CommonUse/build_URL';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import Config from '../../config';
import DropDownOptionCard from '../shared-components/drop_down_option_card';
import CommentProcessCodeDesc from './datasets/comment_process_code_desc';


class UpdatePlayerCommentModal extends Component {
  constructor(props) {
    super(props);
    this.state={
        headers: setHeadersForFetch(),
        environment: Config.dataURL.currentEnv,
    }    
}

render() {
     const possibleReviewCodes = CommentProcessCodeDesc.map((optionsList,index) =>
          <DropDownOptionCard options={optionsList} key={index} />
        );
       
return <>
    <Modal className="text-center" show={this.props.openModal}  onHide={() => this.props.onClose()} 
        size="lg" scrollable="true" animation={false}>
            <Modal.Header className="backgroundTopBottom" closeButton>
                <Modal.Title>Player Comments - Update Review Info & Expire Code      
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mx-2 text-left row">
                    <div className="col-sm-3">
                        <b>User Name: &nbsp;</b>{this.props.commentInfo.user}
                    </div>
                    <div className="col-sm-9">
                        <b>Date/TimeAdded: &nbsp;</b>
                            {this.props.commentInfo.dateAdded} / {this.props.commentInfo.timeAdded}
                    </div>
                </div>
                <div className="mx-2 text-left row">
                    <div className="col-sm-3">
                        <b>ThumbsIcon: &nbsp;</b>
                            <img src={this.props.commentInfo.thumbURL} 
                                    className="thumbs-img-feedback-small" alt={"thumbURL"} />
                    </div>
                    <div className="col-sm-9">
                        <b>Comment: &nbsp;</b> {this.props.commentInfo.comment}
                    </div>
                </div>
                {this.props.commentInfo.reviewCode !== "" ?
                    <>
                      
                        <div className="mx-2 text-left row"> 
                            <div className="col-sm-3">
                                <b>Review Code: &nbsp;</b>{this.props.commentInfo.reviewCode}
                            </div>
                            <div className="col-sm-9">
                                <b>Code Definition: &nbsp;</b>{this.props.commentInfo.reviewCodeDesc}
                            </div>
                        </div>
                        <div className="mx-2 text-left row">
                            <div className="col-sm-3">
                                <b>Review Comment: &nbsp;</b> 
                            </div>
                            <div className="col-sm-9">
                                {this.props.commentInfo.reviewComment}
                            </div>
                        </div>
                        <div className="mx-2 text-left row">
                            <div className="col-sm-3"></div>
                            <div className="col-sm-9">
                                <b>Review Status: &nbsp;</b> {this.props.commentInfo.reviewStatus} 
                            </div>
                        </div>
                    </>  
                    :
                        null
                }
                <div className="text-center mt-4 font-weight-bold">
                    -----------------------  Update Values ------------------------
                </div>
                <div className="mt-2 text-left">
                    <label className="font-weight-bold" htmlFor="reviewCode">
                        Review Code:&nbsp;&nbsp;</label>
                    <select 
                        className="btn btn-sm btn-outline-secondary dropdown-toggle" id="reviewCode">
                        {possibleReviewCodes}
                    </select>
                </div>
                
                <div className="mt-2 text-left">
                    <label className="font-weight-bold" htmlFor="reviewComment">
                        Review Comment:&nbsp;&nbsp;</label>
                    <textarea className="form-control" rows="3" id="reviewComment"></textarea> 
                </div> 
                  
                <div className="mt-2 text-left">
                  <label className="font-weight-bold" htmlFor="reviewStatus">Review Status:&nbsp;&nbsp;</label>
                  <select 
                    className="btn btn-sm btn-outline-secondary dropdown-toggle" id="reviewStatus">
                        <option value="active">Comment Should Remain in Collection</option>
                        <option value="archive">Move Comment to Archive</option>
                  </select>
                </div>   
    
                     
        </Modal.Body>
        <Modal.Footer className="backgroundTopBottom p-0" >
              <Button variant="secondary"  onClick={() => this.getInputAndUpdate()}>
                   Update Comment
              </Button>
              <Button variant="primary"  onClick={() => this.props.onClose()}>
                   Close
              </Button>
              
        </Modal.Footer>
       
    </Modal>
              
   </>
  }

getInputAndUpdate(){
    let reviewCode = document.getElementById("reviewCode").value;
    let reviewComment = document.getElementById("reviewComment").value;
    let reviewStatus = document.getElementById("reviewStatus").value;
    if (reviewCode === "0" && reviewCode !== this.props.commentInfo.reviewCode){
        reviewCode = this.props.commentInfo.reviewCode;
    }
    if (reviewComment === "" && reviewComment !== this.props.commentInfo.reviewComment){
        reviewComment = this.props.commentInfo.reviewComment;
    }
    if (reviewStatus === "Active" && reviewStatus !== this.props.commentInfo.reviewStatus){
        reviewStatus = this.props.commentInfo.reviewStatus;
    }
    this.reviewObj = {code: reviewCode, comment: reviewComment, reviewStatus: reviewStatus};
    this.updatePlayerComment();
   
}


updatePlayerComment(){
     
    this.bodyObj={commentID: this.props.commentInfo.commentID,  reviewed: this.reviewObj };
    const funcName = "updatePlayerFeedback";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
            {method:'PUT', headers: this.state.headers,
            body: JSON.stringify(this.bodyObj)})
            .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    console.log("status code is: ", statusCode);
                    if (statusCode === 200){
                        this.updatedReviewComment = output.body;
                        console.log("updatedReviewComment: ", this.updatedReviewComment);
                        this.props.onClose(this.updatedReviewComment);
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: this.bodyObj};
                        this.props.processError(errorObj);
                    }
                });
            };
        })
    }

}

export default UpdatePlayerCommentModal;